/* Razvan Garage – „Cumpărate frecvent împreună” */
if (!customElements.get('rg-fbt')) {
  customElements.define('rg-fbt', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      const param = (new URLSearchParams(window.location.search).get('rg_fbt') || '').toLowerCase();
      if (this.hasAttribute('data-standby') && param !== 'd') {
        this.remove();
        return;
      }
      if (this.dataset.slot === 'section') {
        if (param === 'd' && document.querySelector('rg-fbt[data-slot="block"]')) {
          this.remove();
          return;
        }
        if (['a', 'b', 'c', 'd'].includes(param)) this.setLayout(param);
      }

      this.list = this.querySelector('[data-rg-fbt-list]');
      this.button = this.querySelector('[data-rg-fbt-add]');
      this.status = this.querySelector('[role="alert"]');
      this.addEventListener('change', (event) => {
        if (event.target.matches('.rg-fbt-item__check')) this.update();
      });
      this.button.addEventListener('click', () => this.add());
      const toggle = this.querySelector('[data-rg-fbt-toggle]');
      if (toggle) {
        toggle.addEventListener('click', () => {
          const open = !this.hasAttribute('data-open');
          this.toggleAttribute('data-open', open);
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }

      const variantsJson = this.querySelector('[data-rg-fbt-variants]');
      if (variantsJson) {
        try { this.variants = JSON.parse(variantsJson.textContent); } catch (error) { this.variants = null; }
        if (this.variants) {
          document.addEventListener('change', (event) => {
            if (!this.contains(event.target)) setTimeout(() => this.syncVariant(), 80);
          });
        }
      }

      if (this.dataset.recsUrl) {
        this.loadRecs();
      } else {
        this.show();
      }
    }

    setLayout(layout) {
      this.classList.remove('rg-fbt--a', 'rg-fbt--b', 'rg-fbt--c', 'rg-fbt--d');
      this.classList.add('rg-fbt--' + layout);
      this.dataset.layout = layout;
    }

    show() {
      if (!this.querySelector('[data-rg-fbt-item]:not([data-locked])')) return;
      this.buildStack();
      this.hidden = false;
      this.update();
    }

    async loadRecs() {
      try {
        const response = await fetch(this.dataset.recsUrl);
        if (!response.ok) return;
        const html = await response.text();
        const recs = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-rg-fbt-recs]');
        if (!recs || !recs.querySelector('[data-rg-fbt-item]')) return;
        this.list.append(...Array.from(recs.childNodes));
        this.show();
      } catch (error) {}
    }

    buildStack() {
      const stack = this.querySelector('[data-rg-fbt-stack]');
      if (!stack) return;
      stack.textContent = '';
      for (const media of this.querySelectorAll('.rg-fbt-item__media')) {
        const img = media.querySelector('img, svg');
        const dot = document.createElement('span');
        dot.className = 'rg-fbt__dot';
        if (img) dot.append(img.cloneNode(true));
        stack.append(dot);
      }
    }

    syncVariant() {
      const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      const main = this.querySelector('[data-rg-fbt-item]');
      if (!input || !main || !this.variants) return;
      const data = this.variants[input.value];
      if (!data) return;
      main.dataset.variantId = input.value;
      main.dataset.price = data[0];
      main.dataset.compare = data[1];
      main.dataset.available = data[2] ? 'true' : 'false';
      const now = main.querySelector('.rg-fbt-item__now');
      if (now) {
        const sign = now.querySelector('.rg-fbt-item__plus-sign');
        now.textContent = this.money(data[0]);
        if (sign) now.prepend(sign);
      }
      this.update();
    }

    money(cents) {
      const value = Number(cents) / 100;
      const fmt = this.dataset.moneyFormat || '';
      const parts = (decimals, thousands, separator) => {
        const fixed = value.toFixed(decimals).split('.');
        const whole = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return fixed[1] ? whole + separator + fixed[1] : whole;
      };
      const map = {
        amount: () => parts(2, ',', '.'),
        amount_no_decimals: () => parts(0, ',', '.'),
        amount_with_comma_separator: () => parts(2, '.', ','),
        amount_no_decimals_with_comma_separator: () => parts(0, '.', ','),
        amount_with_apostrophe_separator: () => parts(2, "'", '.')
      };
      const match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
      if (!match) return parts(2, '.', ',') + ' lei';
      return fmt.replace(match[0], (map[match[1]] || map.amount_with_comma_separator)());
    }

    selected() {
      return Array.from(this.querySelectorAll('[data-rg-fbt-item]')).filter((item) => {
        const box = item.querySelector('.rg-fbt-item__check');
        const on = box ? box.checked : true;
        item.classList.toggle('is-off', !on);
        return on;
      });
    }

    update() {
      const items = this.selected();
      let total = 0;
      for (const item of items) total += Number(item.dataset.price) || 0;
      const percent = Number(this.dataset.percent) || 0;
      // Economia afișată = doar reducerea de pachet (nu diferența față de prețul tăiat).
      const bundle = this.dataset.discount && percent > 0 && items.length > 1 ? Math.round(total * percent / 100) : 0;
      const final = total - bundle;
      const layout = this.dataset.layout;
      const save = this.dataset.labelSave || '';

      this.querySelector('[data-rg-fbt-total]').textContent = this.money(final);
      const was = this.querySelector('[data-rg-fbt-was]');
      was.hidden = bundle <= 0;
      was.textContent = this.money(total);
      const saveEl = this.querySelector('[data-rg-fbt-save]');
      saveEl.hidden = bundle <= 0;
      saveEl.textContent = save + ' ' + this.money(bundle) + (layout === 'd' ? ' cumpărându-le împreună' : '');

      const stripTotal = this.querySelector('[data-rg-fbt-strip-total]');
      if (stripTotal) stripTotal.textContent = this.money(final);
      const stripSave = this.querySelector('[data-rg-fbt-strip-save]');
      if (stripSave) {
        stripSave.hidden = bundle <= 0;
        stripSave.textContent = save + ' ' + this.money(bundle) + ' (−' + percent + '% la pachet)';
      }

      let label = items.length > 1 ? this.dataset.labelMany : this.dataset.labelOne;
      if (layout === 'd') label = (items.length > 1 ? 'Adaugă toate ' + items.length : this.dataset.labelOne) + ' · ' + this.money(final);
      if (layout === 'c') label = label + ' · ' + this.money(final);
      if (!this.pending) this.button.textContent = label;

      const main = this.querySelector('[data-rg-fbt-item]');
      this.button.disabled = Boolean(main && main.dataset.available === 'false');
    }

    async add() {
      if (this.pending) return;
      this.pending = true;
      const items = this.selected();
      const code = this.dataset.discount && items.length > 1 ? this.dataset.discount : '';
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.status.hidden = true;
      let added = false;
      try {
        const codes = [];
        if (code) {
          const cartResponse = await fetch(this.dataset.cartUrl + '.js', {credentials: 'same-origin'});
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            for (const entry of cart.discount_codes || []) if (entry.code) codes.push(entry.code);
            for (const application of cart.cart_level_discount_applications || []) {
              if (application.type === 'discount_code') codes.push(application.title);
            }
            for (const line of cart.items || []) {
              for (const allocation of line.line_level_discount_allocations || []) {
                if (allocation.discount_application && allocation.discount_application.type === 'discount_code') {
                  codes.push(allocation.discount_application.title);
                }
              }
            }
          }
        }
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items: items.map((item) => ({id: Number(item.dataset.variantId), quantity: 1}))})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
        added = true;
        this.button.textContent = this.dataset.labelAdded;
        if (code) {
          const discountResponse = await fetch(this.dataset.updateUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({discount: [...new Set([...codes, code])].join(',')})
          });
          if (!discountResponse.ok) throw new Error(this.dataset.error);
        }
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        if (added) {
          window.location.assign('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(this.dataset.cartUrl));
          return;
        }
        this.status.textContent = error.message || this.dataset.error;
        this.status.hidden = false;
        this.pending = false;
        this.button.removeAttribute('aria-busy');
        this.update();
      }
    }
  });
}
